export default {
  registrationCompleted (state) {
    return state.autenticacao.status === 0 || state.autenticacao.status === 4
  },
  registrationStatusMessage (state) {
    switch (state.autenticacao.status) {
      case 0:
        return 'você completou 100% do seu cadastro.'
      case 1:
        return 'você ainda não confirmou seu email!'
      case 2:
        return 'Ainda faltam algumas informações do seu cadastro, isso impacta diretamente nas suas vendas.'
      case 3:
        return 'estamos analizando as informações, aguarde a sua homologação 90% realizado.'
      case 4:
        return 'primeiro acesso você completou somente 100% do seu cadastro, boas vendas.'
    }
  },
  autenticacao (state) {
    return state.autenticacao.autenticado
  },
  token (state) {
    return state.autenticacao.token
  },
  nome (state) {
    return state.autenticacao.nome
  },
  statusCode (state) {
    return state.autenticacao.status
  },
  status (state) {
    switch (state.autenticacao.status) {
      case 0:
        // homologado 100%
        return 100
      case 1:
        // não confirmou o email
        return 0
      case 2:
        // falta completar o cadastro
        return 60
      case 3:
        // fez update do cadastro porem está esperando homologação
        return 90
      case 4:
        // primeiro acesso apos ser homologado já foi homologado
        return 100
    }
  },
  usuario (state) {
    return state.usuario
  },
  loadingAutenticacao (state) {
    return state.loading
  }
}



// WEBPACK FOOTER //
// ./src/store/autenticacao/getters.js